import { AirSpaceBoundaryCoordinatePointModel } from "./air-space-boundary-coordinate-point";
import { AirSpaceBoundaryVertexLine } from "./AirSpaceBoundaryVertexLine";
import { NavaidModel } from "./navaid";

export interface AirSpaceBoundary {
  id:number,
  name: string,
  uniqueid : string,
  airspaceboundaryid: string,
}

export class AirSpaceBoundaryModel implements AirSpaceBoundary {
id:number;
name: string;
uniqueid : string;
airspaceboundaryid: string;
airSpaceBoundaryCoordinatePoints: AirSpaceBoundaryCoordinatePointModel[] = [];
airSpaceBoundaryLines: AirSpaceBoundaryVertexLine[] = [];
navaids : NavaidModel[] = [];
isselected:boolean = false;
mapstatus: boolean = true;

getInformation(){
  let information = "";

  information += '<h4 style="font-weight:bold">AirSpace Boundary</h4>';
  information += "<p>ID: " + this.airspaceboundaryid + "</p>";
  information += "<p>Name: " + this.name + "</p>";
  information += "<p>Total Points: " + this.airSpaceBoundaryCoordinatePoints.length + "</p>";

  return information;
}
}
